import React, { useEffect, useState } from 'react';
import LeftPanel from './LeftPannel';
import { useAuthStatus, useUserSelector } from '../store/selectors/userSelector';
import { useResolvedPath } from 'react-router-dom';
import { STORAGE } from '../_config';

interface LayoutProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    const loggedinuser: any = useUserSelector();
    const isAuth = useAuthStatus();
    const childUrl = useResolvedPath(``).pathname; // 'child' is the relative path
    const [allowedRoute, setAllowedRoute] = useState<boolean>(true);

    useEffect(() => {
        if (isAuth && loggedinuser) {
            console.log(loggedinuser);
            if (loggedinuser.userTypeID && ![1].includes(loggedinuser.userTypeID)) {
                const permissions = loggedinuser.module.filter((o: any) => !o.isTemplate);
                const found_access = permissions.map((o: any) => o.url).find((o: any) => {
                    //console.log("O is", permissions.map((o: any) => o.url), (childUrl + `===` + o));
                    if (o.includes(`^`)) {
                        return childUrl.startsWith(o.replace(`^`, ``))
                    } else {
                        return (childUrl === o)
                    }
                });
                if (!found_access) {
                    //(window as any).location.href = `/no-access`;
                    setAllowedRoute(false);
                }
            }
            //console.log("Loggedin user from router master", loggedinuser.module, childUrl, found_access);
        }
    }, [isAuth, loggedinuser]);

    return (
        <div className='h-screen w-screen flex'>
            <LeftPanel />
            {allowedRoute ? (
                <main className="layout-content flex-grow overflow-auto h-screen">
                    {children}
                </main>
            ) : (
                <main className="layout-content flex-grow overflow-auto h-screen">
                    <div className="flex flex-col items-center justify-center h-full text-center">
                        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md">
                            <svg className="mx-auto mb-4 h-16 w-16 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 48 48" aria-hidden="true">
                                <circle cx="24" cy="24" r="22" strokeWidth="4" />
                                <path strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" d="M16 16l16 16M32 16l-16 16" />
                            </svg>
                            <h1 className="text-2xl font-bold text-gray-800 mb-2">Access Denied</h1>
                            <p className="text-gray-600 mb-6">
                                You do not have permission to view this page.<br />
                                Please contact your administrator if you believe this is an error.
                            </p>
                            <a href="/" className="inline-block px-6 py-2 bg-green-800 text-white rounded hover:bg-red-600 transition">
                                Go to Home
                            </a>
                        </div>
                    </div>
                </main>
            )}


        </div>
    );
};

export default Layout;